import angular from 'angular';
import ListingComponent from './components/listing';
import ListingAddComponent from './components/add';
import ListingEditComponent from './components/edit';
import CategoryListComponent from './components/category_listing';
import CategoryAddComponent from './components/category_add';
import CategoryEditComponent from './components/category_edit';
import SubCategoryListComponent from './components/subcategory_listing';
import SubCategoryAddComponent from './components/subcategory_add';
import SubCategoryEditComponent from './components/subcategory_edit';
import {ProductPageConfig} from './components/product-page.config';
import uiRouter from 'angular-ui-router';
import ngFileUpload from 'ng-file-upload';
import ProductPages from './services/products.pages.service';
import ProductPagesDataProvider from './services/products.pages.dataprovider.service';

export default angular.module('product-page', [uiRouter, ngFileUpload])
  .component('productPagesListing', ListingComponent)
  .component('productPageAdd', ListingAddComponent)
  .component('productPageEdit', ListingEditComponent)
  .component('productPageCategoryList', CategoryListComponent)
  .component('categoryAdd', CategoryAddComponent)
  .component('categoryEdit', CategoryEditComponent)
  .component('subCategoryList', SubCategoryListComponent)
  .component('subCategoryAdd', SubCategoryAddComponent)
  .component('subCategoryEdit', SubCategoryEditComponent)
  .service('ProductPages', ProductPages)
  .service('ProductPagesDataProvider', ProductPagesDataProvider)
  .config(ProductPageConfig)
  .name


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/product-page/index.js
 **/